import type { ReactNode } from 'react';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupIcon from '@mui/icons-material/Group';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import i18n from 'src/i18n/i18n';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import ListAltIcon from '@mui/icons-material/ListAlt';

export interface MenuItem {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  badgeTooltip?: string;
  permission?: string;

  items?: MenuItem[];
  name: string;
}

export interface MenuItems {
  items: MenuItem[];
  heading: string;
}


const menuItems: MenuItems[] = [
  {
    heading: 'Menu',
    items: [
      {
        name: 'Dashboard',
        link: '/admin/dashboard',
        icon: <DashboardIcon />,
        permission: 'others.view_dashboard'
      },
      {
        name: i18n.t('INVOICER-XML-TO-PDF.HEADING'),
        link: '/admin/invoicer-xml-to-pdf',
        icon: <PictureAsPdfIcon />,
        permission: 'others.view_dashboard'
      },
      {
        name: i18n.t('INVOICER-XML-TO-LIST.HEADING'),
        link: '/admin/invoicer-xml-to-list',
        icon: <ListAltIcon />,
        permission: 'others.view_dashboard'
      },
      {
        name: i18n.t('INVOICE-EXPEDITORS.HEADING'),
        link: '/admin/invoice-expeditors',
        icon: <AssignmentIndIcon />,
        permission: 'invoice_catalogs.list'
      },
      {
        name: i18n.t('CLIENTS.HEADING'),
        link: '/admin/clients',
        icon: <GroupIcon />,
        permission: 'clients.list'
      },
      {
        name: i18n.t('INVOICE-CLIENT-CONFIGS.HEADING'),
        link: '/admin/invoice-client-configs',
        icon: <ManageAccountsIcon />,
        permission: 'invoices.client_config'
      },
      {
        name: i18n.t('INVOICE-COMBINE-KEYS.HEADING'),
        link: '/admin/invoice-combine-keys',
        icon: <LibraryAddIcon />,
        permission: 'invoices.client_config'
      },
      {
        name: i18n.t('GENERIC-INVOICE-CATALOGS.HEADING'),
        link: '/admin/invoice-catalogs?catalog=InvoiceCatalogCfdiUses',
        icon: <LibraryBooksIcon />,
        permission: 'invoice_catalogs.all'
      },
      {
        name: i18n.t('ROLES.HEADING'),
        link: '/admin/roles',
        icon: <VerifiedUserIcon />,
        permission: 'roles.list'
      },
      {
        name: i18n.t('USERS.HEADING'),
        link: '/admin/users',
        icon: <AccountBoxIcon />,
        permission: 'users.list'
      }
    ]
  }
];

export default menuItems;
